import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  style: {
    "color": "red"
  }
};
var _hoisted_2 = {
  key: 1
};
import { searchFormItems, editFormItems, editRules, addFormItems, addRules } from './config';
import { BASE_URL, PAGE_URL, updateUseFlag, updateLocationEnable, remove, getAdminLocalVer, updateAdminLocalVer } from '@/api/baseSetting/anchorpoint/anchorpoint';
import { Edit, Delete } from '@element-plus/icons-vue';
import { deleteBox, toast, warningBox } from '@/utils/message';
import { XTable } from '@/components/index';
import { COMMON_ENABEL_STATUS } from '@/constant/system/code';
import useStore from "@/store";
import { formatterDate } from '@/utils/common';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Anchorpoint',
  setup: function setup(__props) {
    var tableInstance = ref();
    var addFormInstance = ref();
    var editFormInstance = ref();
    var searchData = {};
    var adminLocalVer = ref('0');
    var headerButton = [
      // tableAddHeader(() => {
      //   addFormInstance.value?.open()
      // }),
      // tableEditHeader((rows: any[]) => {
      //   if(isOnlyOne(rows)) {
      //     editFormInstance.value?.open(rows[0].id)
      //   }
      // }),
      // tableDeleteHeader((rows: any[]) => {
      //   if(rows.length === 0) {
      //     toast.warn('请至少选择一条数据')
      //     return
      //   }
      //   deleteBox().then(() => {
      //     remove(rows.map(i => i.id)).then(() => {
      //       toast.success('删除成功')
      //       tableInstance.value?.load(searchData)
      //     })
      //   })
      // }),
    ];
    var handleUpdateAdminLocalVer = function handleUpdateAdminLocalVer() {
      var adminLocalVerData = {
        id: 1,
        status: adminLocalVer.value
      };
      var noticeMsg = adminLocalVer.value === '0' ? '确认关闭小程序管理员的定位验证吗？' : '确认开启小程序管理员的定位验证吗？';
      warningBox(noticeMsg).then(function () {
        updateAdminLocalVer(adminLocalVerData).then(function () {
          toast.success('更新成功');
          getAdminLocalVerData();
        });
      }).catch(function () {
        getAdminLocalVerData();
      });
    };
    var addWin = function addWin() {
      var _addFormInstance$valu;
      (_addFormInstance$valu = addFormInstance.value) === null || _addFormInstance$valu === void 0 || _addFormInstance$valu.open();
    };
    function search(formDara) {
      var _tableInstance$value;
      searchData = formDara;
      (_tableInstance$value = tableInstance.value) === null || _tableInstance$value === void 0 || _tableInstance$value.load(formDara);
      getAdminLocalVerData();
    }
    function reset() {
      var _tableInstance$value2;
      searchData = {};
      (_tableInstance$value2 = tableInstance.value) === null || _tableInstance$value2 === void 0 || _tableInstance$value2.load({});
    }
    function handleUpdateItem(row) {
      var _editFormInstance$val;
      (_editFormInstance$val = editFormInstance.value) === null || _editFormInstance$val === void 0 || _editFormInstance$val.open(row.id);
    }
    function handleRemoveItem(row) {
      deleteBox().then(function () {
        remove([row.id]).then(function () {
          var _tableInstance$value3;
          toast.success('删除成功');
          (_tableInstance$value3 = tableInstance.value) === null || _tableInstance$value3 === void 0 || _tableInstance$value3.load(searchData);
        }).catch(function (e) {
          toast.error(e.message);
        });
      }).catch(function () {});
    }
    function tableReLoad() {
      var _tableInstance$value4;
      (_tableInstance$value4 = tableInstance.value) === null || _tableInstance$value4 === void 0 || _tableInstance$value4.load(searchData);
    }
    /**
     * 编辑状态权限
     */
    var adminLoaclVerEnable = computed(function () {
      if (useStore().user.actions.filter(function (item) {
        return item.authorityCode === 'manage:anchor-point:adminLoaclVerFlag';
      }).length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 编辑状态权限
     */
    var useFlagEnable = computed(function () {
      if (useStore().user.actions.filter(function (item) {
        return item.authorityCode === 'manage:anchor-point:updateUseFlag';
      }).length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 修改启用状态
     * @param row
     */
    function handleUpdateUseFlag(row) {
      updateUseFlag({
        'id': row.id,
        'useFlag': row.useFlag
      }).then(function () {
        toast.success('操作成功');
        tableReLoad();
      });
    }
    /**
     * 编辑定位权限
     */
    var locationEnable = computed(function () {
      if (useStore().user.actions.filter(function (item) {
        return item.authorityCode === 'manage:anchor-point:updateLocationEnable';
      }).length > 0) {
        return false;
      } else {
        return true;
      }
    });
    /**
     * 修改定位状态
     * @param row
     */
    function handleUpdateLocationEnable(row) {
      updateLocationEnable({
        'id': row.id,
        'locationVerification': row.locationVerification
      }).then(function () {
        toast.success('操作成功');
        tableReLoad();
      });
    }
    /**
     * 查询指定ID的管理员定位限制状态
     */
    var getAdminLocalVerData = function getAdminLocalVerData() {
      getAdminLocalVer(1).then(function (res) {
        adminLocalVer.value = res.data.status;
      });
    };
    getAdminLocalVerData();
    return function (_ctx, _cache) {
      var _component_XSearchForm = _resolveComponent("XSearchForm");
      var _component_el_button = _resolveComponent("el-button");
      var _component_ElSwitch = _resolveComponent("ElSwitch");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_link = _resolveComponent("el-link");
      var _component_ElTableColumn = _resolveComponent("ElTableColumn");
      var _component_XFormDialog = _resolveComponent("XFormDialog");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_XSearchForm, {
            ref: "searchForm",
            items: _unref(searchFormItems),
            onSearch: search,
            onReset: reset
          }, null, 8, ["items"]), _createVNode(_component_el_row, {
            gutter: 24,
            style: {
              "margin-bottom": "20px"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_button, {
                    icon: "Plus",
                    type: "primary",
                    onClick: addWin
                  }, {
                    default: _withCtx(function () {
                      return _cache[2] || (_cache[2] = [_createTextVNode("新增")]);
                    }),
                    _: 1
                  }), _cache[3] || (_cache[3] = _createElementVNode("span", {
                    style: {
                      "padding": "0 6px 0 44px"
                    }
                  }, "小程序管理员定位验证：", -1)), _createVNode(_component_ElSwitch, {
                    modelValue: _unref(adminLocalVer),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _isRef(adminLocalVer) ? adminLocalVer.value = $event : adminLocalVer = $event;
                    }),
                    disabled: _unref(adminLoaclVerEnable),
                    "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
                    "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
                    onChange: _cache[1] || (_cache[1] = function ($event) {
                      return handleUpdateAdminLocalVer();
                    })
                  }, null, 8, ["modelValue", "disabled", "active-value", "inactive-value"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_unref(XTable), {
            ref_key: "tableInstance",
            ref: tableInstance,
            url: _unref(PAGE_URL),
            selectable: false,
            "header-buttons": headerButton,
            "el-table-props": {
              border: true
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_ElTableColumn, {
                label: "操作",
                align: "center",
                width: "130"
              }, {
                default: _withCtx(function (_ref) {
                  var row = _ref.row;
                  return [_createVNode(_component_el_link, {
                    underline: false,
                    icon: _unref(Edit),
                    type: "primary",
                    onClick: function onClick($event) {
                      return handleUpdateItem(row);
                    }
                  }, {
                    default: _withCtx(function () {
                      return _cache[4] || (_cache[4] = [_createElementVNode("span", {
                        style: {
                          "padding": "0 6px 0 4px"
                        }
                      }, "编辑", -1)]);
                    }),
                    _: 2
                  }, 1032, ["icon", "onClick"]), _createVNode(_component_el_link, {
                    underline: false,
                    icon: _unref(Delete),
                    type: "primary",
                    onClick: function onClick($event) {
                      return handleRemoveItem(row);
                    }
                  }, {
                    default: _withCtx(function () {
                      return _cache[5] || (_cache[5] = [_createElementVNode("span", {
                        style: {
                          "padding-left": "4px"
                        }
                      }, "删除", -1)]);
                    }),
                    _: 2
                  }, 1032, ["icon", "onClick"])];
                }),
                _: 1
              }), _createVNode(_component_ElTableColumn, {
                label: "锚位",
                prop: "anchorPoint"
              }), _createVNode(_component_ElTableColumn, {
                label: "经度",
                prop: "longitude",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "纬度",
                prop: "latitude",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "心跳编码",
                prop: "anchorPointHeart",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "指令编码",
                prop: "anchorPointOrder",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "锚位状态",
                prop: "status",
                align: "center"
              }, {
                default: _withCtx(function (_ref2) {
                  var row = _ref2.row;
                  return [row.status === '异常' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.status), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(row.status), 1))];
                }),
                _: 1
              }), _createVNode(_component_ElTableColumn, {
                label: "使用标记",
                prop: "useFlag",
                align: "center"
              }, {
                default: _withCtx(function (_ref3) {
                  var row = _ref3.row;
                  return [_createVNode(_component_ElSwitch, {
                    modelValue: row.useFlag,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return row.useFlag = $event;
                    },
                    disabled: _unref(useFlagEnable),
                    "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
                    "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
                    onChange: function onChange($event) {
                      return handleUpdateUseFlag(row);
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "active-value", "inactive-value", "onChange"])];
                }),
                _: 1
              }), _createVNode(_component_ElTableColumn, {
                label: "定位验证",
                prop: "locationVerification",
                align: "center"
              }, {
                default: _withCtx(function (_ref4) {
                  var row = _ref4.row;
                  return [_createVNode(_component_ElSwitch, {
                    modelValue: row.locationVerification,
                    "onUpdate:modelValue": function onUpdateModelValue($event) {
                      return row.locationVerification = $event;
                    },
                    disabled: _unref(locationEnable),
                    "active-value": _unref(COMMON_ENABEL_STATUS).ENABLED.CODE,
                    "inactive-value": _unref(COMMON_ENABEL_STATUS).DISABLED.CODE,
                    onChange: function onChange($event) {
                      return handleUpdateLocationEnable(row);
                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "active-value", "inactive-value", "onChange"])];
                }),
                _: 1
              }), _createVNode(_component_ElTableColumn, {
                label: "创建者",
                prop: "nickname",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "创建时间",
                prop: "createdAt",
                align: "center",
                width: "160",
                formatter: function formatter(row) {
                  return _unref(formatterDate)(row.createdAt);
                }
              }, null, 8, ["formatter"])];
            }),
            _: 1
          }, 8, ["url"]), _createVNode(_component_XFormDialog, {
            ref_key: "editFormInstance",
            ref: editFormInstance,
            title: "编辑",
            form: {
              items: _unref(editFormItems),
              loadUrl: _unref(BASE_URL),
              saveUrl: _unref(BASE_URL),
              saveMethods: 'put',
              elFormProps: {
                rules: _unref(editRules)
              }
            },
            onSaveSuccess: tableReLoad
          }, null, 8, ["form"]), _createVNode(_component_XFormDialog, {
            ref_key: "addFormInstance",
            ref: addFormInstance,
            title: "新增",
            form: {
              items: _unref(addFormItems),
              saveUrl: _unref(BASE_URL),
              elFormProps: {
                rules: _unref(addRules)
              }
            },
            onSaveSuccess: tableReLoad
          }, null, 8, ["form"])];
        }),
        _: 1
      });
    };
  }
});